module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp2-5e4b772bd81e0ed1756c252c7c3ed672.jpg";